export default __webpack_public_path__ + "static/img_product_orc@2x-203bda448033c9294d914669ad81289e.png";